import * as React from 'react';
import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperProps, Navigation, Pagination } from 'swiper';
import { getLinks, imgConf } from './config';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const UGC = () => {
    const { t } = useLang('membersday.story');
    const { locale } = getLocal();

    const [activeIndex, setActiveIndex] = React.useState(0);

    const swiperConfig = {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto' as const,
        initialSlide: 0,
        navigation: true,
        pagination: { clickable: true },
        onSlideChange: (swiper: SwiperProps) => {
            setActiveIndex(swiper.activeIndex);
        },
    };

    const currentStories = imgConf[locale] || imgConf['us'];

    const handleShare = () => {
        let method = 'facebook';
        if (locale === 'jp') {
            method = 'twitter';
        }
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join',
                list_name: 'Share your story',
                button_name: `${t('buttonName')}_${t('title')}`,
            });
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div className={styled.UGC} id="UGC">
            <div className="ugc-title">{t('title')}</div>
            <div className="ugc-sub-title">{t('desc')}</div>
            <div className="fy2025-ugc-row">
                <EfLink className="fy2025-ugc-link" href={getLinks(locale)} onClick={handleShare}>
                    {t('buttonName')}
                </EfLink>
            </div>
            <Swiper className={`story active-${activeIndex}`} {...swiperConfig}>
                {currentStories.map((item, index) => (
                    <SwiperSlide className={`card item-${index + 1}`} key={index}>
                        <div className="item-img">
                            <EfImg pc={item?.pc} h5={item?.h5} />
                        </div>
                        <div className="item-info">
                            {/* {item.title && <p className="item-title">{t(`story${index + 1}_title`)}</p>} */}
                            <div className="item-desc">{t(`story${index + 1}_desc`)}</div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default UGC;
